<!--
  Deprecated - use directly going forward.
-->
<template>
  <div>
  </div>
</template>
<script>
import { memoize, throttle } from 'lodash';
import { mapGetters } from 'vuex';

export default {
  name: 'VNotifications',
  computed: {
    ...mapGetters({
      notificationsEnabled: 'notifications/enabled',
    }),
  },
  created() {
    // Memoise and Throttle a function.
    // Stops it from being called too often based on same params.
    function memoizeThrottle(func, wait = 0, options = {}) {
      const mem = memoize(() => throttle(func, wait, options), options.resolver);
      // Memoise based on the message property - this should not be an arrow function
      return function () { // eslint-disable-line func-names
        mem.call(this, ...arguments[0].message).apply(this, arguments); // eslint-disable-line prefer-rest-params
      };
    }

    const showMessage = ({ message, type }) => {
      // TODO - remove this file and use directly.
      const title = type === 'success' ? 'Success' : 'Error';
      let icon;

      switch (type) {
        case 'success':
          icon = 'el-icon-check';
          break;
        case 'error':
        case 'danger':
          icon = 'el-icon-help';
          break;
        case 'warning':
          icon = 'el-icon-warning';
          break;
        case 'info':
        default:
          icon = 'el-icon-info';
      }

      if (this.notificationsEnabled) {
        this.$notify({
          title,
          iconClass: icon,
          message,
          customClass: type,
          position: 'bottom-left',
        });
      }
    };

    // Only call once every 2 seconds. Don't call final time.
    const throttled = memoizeThrottle(showMessage, 2000, { trailing: false });

    this.$bus.$on('renderGlobalMessage', throttled);
  },
};
</script>
